// src/pages/History/EarlyModern/OttomanEmpire.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Early_Modern_Period_-_Ottoman_Empire.png';

function HistoryPageOttomanEmpire() {
  return (
    <TopicPage
      topicKey="Ottoman Empire"
      title="History: Ottoman Empire"
      backgroundImage={bg}
      startRoute="/History-Ottoman-Empire-Go"
      scrollLabels={[
        "Rise of the Ottomans",
        "Suleiman the Magnificent",
        "Cultural and Military Achievements",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageOttomanEmpire;
